import React from 'react';
import { css, Theme, useTheme } from "@emotion/react";

import { OnFieldChange } from "core/hooks/useForm";
import Input from "core/Components/Form/Input";
import SearchableList from "core/Components/Form/SearchableList";
import Countries from "core/includes/countries";

type Props = {
    hasError?: boolean,
    onChange: OnFieldChange,
    phoneNumber: string,
    phoneCode: string,
    phoneInputRef?: React.RefCallback<HTMLInputElement>|React.Ref<HTMLInputElement>,
    className?: string,
    isLoading?: boolean,
}
const PhoneNumberInput: React.FC<Props> = (
    {
        hasError,
        onChange,
        phoneNumber,
        phoneCode,
        phoneInputRef,
        className = '',
        isLoading = false,
    }
) => {
    const theme: Theme = useTheme();

    const containerStyle = css`
        position: relative;
        width: 100%;
        height: 100%;
        min-height: 38px;
    `;

    const phoneNumberInput = css`
        margin-top: 0;
        box-sizing: border-box;
        width: 100%;
        font-size: ${theme.forms.label.fontSize};
        z-index: 7;
        padding-top: 0;
    `;

    const searchableListStyle = css`
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 45px;

        .container {
            height: 100%;
            z-index: 8;
        }

        .searchable-list-menu__container {
            top: calc(100% - 5px);
            padding-top: 0;
            background-color: white;
            z-index: 8;

            ul {
                padding-top: 4px;
            }
        }
    `;
    return (
        <div css={containerStyle} className={className}>
            <Input
                hasError={hasError}
                css={phoneNumberInput}
                label="Mobile number"
                name="phone"
                onChange={onChange}
                value={phoneNumber}
                variant='phone number'
                innerRef={phoneInputRef}
                disabled={isLoading}
            />
            <SearchableList
                name="phoneCode"
                options={Countries}
                value={phoneCode}
                onChange={onChange}
                labelField="label"
                valueField="code"
                variant='phone'
                containsSearchBox
                externalInputRef={phoneInputRef}
                phoneCode={phoneCode}
                css={searchableListStyle}
                fieldReadOnly={isLoading}
            />
        </div>
    )
};

export default PhoneNumberInput;
